import axios from 'axios'
import moment from 'moment'
import 'moment-timezone'
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/es5/util/colors'

import App from './App.vue'
import { en } from './locale/en'
import { es } from './locale/es'
import router from './router'
import store from './store'

import socketio from 'socket.io-client'
import FlagIcon from 'vue-flag-icon'
import VueSocketIO from 'vue-socket.io'
import VueVirtualScroller from 'vue-virtual-scroller'
import * as VueGoogleMaps from 'vue2-google-maps'
import Vuelidate from 'vuelidate'
import MultiFiltersPlugin from './plugins/MultiFilters'

import VueClipboard from 'vue-clipboard2'
import { GoogleAnalytics } from '../analytics.js'
import { i18n } from './plugins/i18n'
Vue.config.silent = true

Vue.use(MultiFiltersPlugin)
Vue.use(FlagIcon)

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCT0-TRG6EiG8gRKj7syFaJBt9wsY-en9U',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: "places,drawing"
    // OR: libraries: "places,drawing,visualization"
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: "3.26",
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on("zoom_changed", someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from "vue2-google-maps/src/components/marker"
  //// Vue.component("GmapMarker", GmapMarker)
  //// then disable the following:
  // installComponents: true,
})

Vue.use(VueVirtualScroller)

const SocketInstance = socketio('https://ws.skolable.com/', {
  transports: ['polling'],
  reconnection: true,
  autoConnect: false,
})
Vue.use(
  new VueSocketIO({
    debug: process.env.NODE_ENV == 'production' ? false : true,
    connection: SocketInstance,
  })
)

Vue.use(Vuelidate)
Vue.use(Vuetify, {
  lang: {
    locales: { en, es },
    current: 'en',
    messages: { es, en },
  },
  theme: {
    primary: '#ef565c', // #E53935
    secondary: '#512e6f', // #FFCDD2
    gray: colors.grey,
  },
  options: {
    customProperties: true,
  },
})

/**
 * Google analytics
 */
const googleAnalyticsId = 'G-1JWB4P2B2C'
window.dataLayer = window.dataLayer || []
function gtag() {
  dataLayer.push(arguments)
}
gtag('js', new Date())

gtag('config', googleAnalyticsId)
window.GoogleAnalytics = new GoogleAnalytics(
  process.env.NODE_ENV === 'test' ? null : googleAnalyticsId,
  gtag
)

Vue.prototype.$http = axios
const token = localStorage.getItem('token')
const isSA = JSON.parse(localStorage.getItem('isSA')) === true ? true : false

if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
  Vue.prototype.$http.defaults.headers.common['Content-Type'] =
    'application/json'
} else {
  Vue.prototype.$http.defaults.headers.common['Content-Type'] =
    'application/x-www-form-urlencoded'
}
Vue.prototype.$http.defaults.headers.common['Accept'] = 'application/json'
Vue.prototype.$http.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
Vue.prototype.$http.defaults.headers.common['userType'] = isSA ? 'SA' : 'W'
Vue.prototype.$http.defaults.headers.common['environment'] =
  process.env.VUE_APP_ENVIRONMENT
Vue.prototype.$http.defaults.headers.common['gadgetType'] = 'W'
Vue.config.productionTip = false
Vue.config.disableNoTranslationWarning = true

moment.locale('es')

Vue.filter('formatDate', function (value, tz) {
  if (value !== undefined && tz !== undefined) {
    return moment(new Date(value)).tz(tz).format('DD/MM/YYYY HH:mm:ss')
  }

  if (value !== undefined) {
    return moment(new Date(value)).format('DD/MM/YYYY HH:mm:ss')
  }

  return '-'
})

Vue.filter('formatDateReports', function (value) {
  if (value) {
    return moment(new Date(value)).format('DD/MM/YYYY HH:mm:ss')
  }
  return '-'
})

Vue.filter('formatDateA', function (value) {
  if (value) {
    return moment(new Date(value)).format('DD/MM/YYYY')
  }
  return '-'
})

Vue.filter('formatDateB', function (value) {
  if (value) {
    return moment(new Date(value)).format('HH:mm:ss')
  }
  return '-'
})

Vue.filter('formatDateShort', function (value) {
  if (value) {
    return moment(new Date(value)).format('MMMM DD, YYYY')
  }
  return '---'
})

Vue.filter('formatCurrency', function (value) {
  if (typeof value === 'number') {
    return (
      '$' +
      value.toLocaleString('es-MX', {
        currency: 'MXN',
        style: 'decimal',
        minimumFractionDigits: 2,
        currencyDisplay: 'narrowSymbol',
      })
    )
  }
  return '---'
})

// Vue.directive('click-outside', {
//   bind () {
//       this.event = event => this.vm.$emit(this.expression, event)
//       this.el.addEventListener('click', this.stopProp)
//       document.body.addEventListener('click', this.event)
//   },
//   unbind() {
//     this.el.removeEventListener('click', this.stopProp)
//     document.body.removeEventListener('click', this.event)
//   },

//   stopProp(event) { event.stopPropagation() }
// })

new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount('#app')
